module.exports = __webpack_public_path__ + "img/phones.2dccfa5f.svg";